<template>
  <div>
    <v-icon @click="dialog = true" color="orange">mdi-pencil</v-icon>

    <SysDialog
      v-model="dialog"
      :titulo="'Editar o modulo: ' + editar_item.id + ' - ' + editar_item.descricao"
      txtBotao="Atualizar"
      @click:primary="editarModulo()"
    >
      <Form :item="editar_item" />
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import Form from './Includes/_form.vue';
import { editarModulosConfiguracaoMenuParametrizacao } from '../../Api';

export default {
  components: {
    SysDialog,
    Form
  },
  model: {
    prop: 'editar_item',
    event: 'change-editar'
  },
  props: {
    editar_item: {
      type: Object
    }
  },
  data: () => ({
    dialog: false
  }),
  methods: {
    fecharDialog() {
      this.dialog = false;
    },
    editarModulo() {
      this.$store.dispatch(
        'loading/addRequisicao',
        editarModulosConfiguracaoMenuParametrizacao(this.editar_item)
          .then(() => this.$emit('atualizar-tela-inicial-menu-configuracao-modulo'))
          .catch(() => this.Helpers.logout())
          .finally(() => this.fecharDialog())
        );
    },
  }
}
</script>

<style>

</style>
